import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import LoadingPage from "components/common_components/LoadingPage";

function PrivateRoute({ component: Component, render, ...props }) {
    const { loggedIn } = useSelector((state) => state.Login);

    if (!loggedIn) {
        return <Redirect to="/login" />;
    }

    return (
        <Route
            {...props}
            render={
                render ||
                ((routeProps) => (
                    <Suspense fallback={<LoadingPage />}>
                        <Component {...routeProps} />
                    </Suspense>
                ))
            }
        />
    );
}

export default PrivateRoute;
